import Vue from 'vue'
import Router from 'vue-router'

// 認証関係
import { Auth, Login, LostPassword, ResetPassword } from '@/components/auth'

// ダッシュボード
import { Dashboard, Information, Messages, Forms, UserSettings,
        Form, Chat, Inquiry,
        AdminSettings, AdminIndex, Accounts, Agreement } from '@/components/dashboard'

// コミュニケーション
import Communication from '@/components/communication/Index'

// 共通のコンポーネントを記載
import Footer from '@/components/Footer'
Vue.component('footer-row', Footer)
import Loading from '@/components/Loader'
Vue.component('loading', Loading)

// service
import { Loader, Authenticate, bus, Message } from '@/service'

Vue.use(Router)

let appRouter = new Router({
  routes: [
    {
      path: '/communication/:inquiryToken', component: Communication
    },
    {
      path: '/auth', redirect: '/auth/login'
    },
    {
      path: '/auth',
      component: Auth,
      children: [
        { path: 'login', component: Login },
        { path: 'lost_password', component: LostPassword },
        { path: 'reset_password/:token', component: ResetPassword }
      ]
    },
    {
      path: '/', redirect: '/dashboard/information'
    },
    {
      path: '/dashboard', redirect: '/dashboard/information'
    },
    {
      path: '/dashboard',
      component: Dashboard,
      children: [
        { path: 'information', component: Information },
        { path: 'messages/:id', component: Messages, name: 'messages' },
        { path: 'forms', component: Forms },
        { path: 'form/:id', component: Form, name: 'form' },
        { path: 'usersettings', component: UserSettings },
        { path: 'chat/:id', component: Chat, name: 'chat' },
        { path: 'inquiry', component: Inquiry },
        {
          path: 'adminsettings',
          component: AdminSettings,
          children: [
            { path: '', component: AdminIndex },
            { path: 'accounts', component: Accounts },
            { path: 'agreement', component: Agreement }
          ]
        }
      ]
    }
  ]
})

appRouter.beforeEach((to, from, next) => {
  // ログイン前提の機能はログインチェックを事前に行う
  Loader.show()
  let path = to.path
  if (path.indexOf('/dashboard') > -1) {
    let AuthResult = Authenticate.doAuthorization()
    AuthResult.then((is) => {
      // 画面遷移時にログイン無効
      if (!is) {
        console.log(from.path)
        console.log(to.path)
        if (from.path === '/') {
          next('/auth/login')
        } else {
          Message.show('error', '認証エラーが発生しました。サインインしなおしてください。', {
            autoCloseTime: 5,
            closedExec: () => {
              next('/auth/login')
            }
          })
        }
      } else {
        if (path.indexOf('/adminsettings') > -1) {
          // adminのチェック
          let user = Authenticate.currentUser()
          if (!user.admin) {
            if (from.path === '/') {
              // リロードした場合
              next('/')
            } else {
              // 管理者画面へ画面遷移しようとした
              Message.show('error', '管理権限が必要な操作です。')
            }
          } else {
            next()
          }
        } else {
          next()
        }
      }
    })
  } else {
    next()
  }
})

appRouter.afterEach((to, from) => {
  let path = to.path
  if (path.indexOf('information') > -1) {
    bus.$emit('select_menu', 'message')
  }
  if (path.indexOf('/form') > -1) {
    bus.$emit('select_menu', 'form')
  }
  Loader.hide()
})

export default appRouter



// WEBPACK FOOTER //
// ./src/router/index.js